import heic2any from 'heic2any';

export default (context, inject) => {
  inject('heic2any', heic2any);
}